import React from 'react'
import styled from '@emotion/styled'

import { grayLight30, fontWeightBold, fontSize2XSmall, fontSizeMedium, fontSizeSmall, redLight10 } from '../../constants/principles'
import { BrowserUtils } from '../../utils/siteUtils'
import { AnchorButton } from '../generic/Basics'
import Triangle from '../generic/ExclamationTriangle'

export default ({ title, children, onClick, isError = false, showEdit = true }) => {
  const isDesktop = BrowserUtils.isDesktop()

  return (
    <SectionSection>
      <ErrorDiv>
        {isError && (
          <TriangleDiv>
            <Triangle colorFill={redLight10} height="20px" width="20px" />
          </TriangleDiv>
        )}
        <StyledH1 isDesktop={isDesktop} isError={isError}>
          {title}
        </StyledH1>
      </ErrorDiv>
      {showEdit && (
        <EditDiv isDesktop={isDesktop}>
          <AnchorButton onClick={onClick}>Edit</AnchorButton>
        </EditDiv>
      )}
      <StyledDiv isDesktop={isDesktop}>{children && Object.keys(children).length ? children : `No ${title}`}</StyledDiv>
    </SectionSection>
  )
}

const EditDiv = styled.div`
  ${p => (p.isDesktop ? `position: absolute; left: 95%;` : `margin-top:0px;margin-bottom:12px;`)}
`
const SectionSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${grayLight30};
  padding-bottom: 48px;
  margin: 24px 24px;
  &:last-child {
    border: 0;
  }
`
const ErrorDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
const TriangleDiv = styled.div`
  padding-right: 8px;
`
const StyledDiv = styled.div`
  text-align: center;
  font-size: ${fontSize2XSmall};
  ${p => (p.isDesktop ? `max-width: 75%;` : `width: 100%;`)}
`
const StyledH1 = styled.h1`
  font-weight: ${fontWeightBold};
  font-size: ${fontSizeMedium};
  margin-top: 0px;
  text-align: center;
  margin-bottom: ${p => (p.isDesktop ? 8 : 0)}px;
`
export const StyledSpan = styled.span`
  font-weight: ${fontWeightBold};
  font-size: ${fontSize2XSmall};
`
export const StyledH2 = styled.h2`
  font-weight: ${fontWeightBold};
  font-size: ${fontSizeSmall};
`
export const StyledValue = styled.div`
  margin: 8px 0px;
`
export const StyledBlock = styled.div`
  line-height: 12px;
  margin-bottom: 32px;
`
export const StyledH3 = styled.h3`
  font-weight: ${fontWeightBold};
  font-size: ${fontSize2XSmall};
  line-height: 16px;
`
